import Title from "./Title";
import trust from "../img/trust.png";
import chart from "../img/Chart.png";
export default function Trust() {
    return <>
        <div className="trust py-4 py-lg-5" >
            <div className="container" >
                <div className="row" >
                    <div className="col-xl-6 position-relative pe-xl-4" >
                        <div className="trustImage " >
                            <img className="img-fluid" src={trust} alt="trust" />
                        </div>
                        <div className="trustGraph rounded-white" >
                            <div className="graph-content">
                                <h2>Total Packing Orders</h2>
                                <h3>1m+ <span>99%</span></h3>
                            </div>
                            <div className="graph-chart">
                                <img className="img-fluid" src={chart} alt="image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 ps-xl-4 mt-3 mt-sm-4 mt-xl-0" >
                        <Title mainClass="m-auto d-table mb-2 mb-sm-5"
                            titleclass="lg text-dark text-center text-lg-start mb-3 mb-sm-4"
                            desclass="mt-2 text-center text-lg-start mb-2"
                            title={<> We are Professional movers you can trust ! </>}
                            des="Whether moving down the street, across the country, or to a new home or business building, we’re here to help with managing relocation stress." />
                        <div className="trustRatio" >
                            <ul>
                                <li>
                                    <div className="ratioB">
                                        <h2>98%</h2>
                                        <p>Customer Referral Rate</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="ratioB active">
                                        <h2>5k+</h2>
                                        <p>Moving Trucks on the Road</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="ratioB">
                                        <h2>410+</h2>
                                        <p>Global locations Worldwide</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}
